import axios from "../axios";
import { responseHandler, errorHandler } from "../utils/handlers";
import { USERS_URI } from "../constants/uri";
// import { PAGINATION } from "../constants/query";
// import { buildParams } from "../utils/params";

/**
 * Get user collection or instance
 * @param {number} id
 * @return {Promise} AxiosResponse with user details
 */
export const get = (id) => {
  return id ? getUser(id) : getUsers()
}

/**
 * Get sepcified user
 * @param  {number}  id - Specified user to retrieve
 * @return {Promise} AxiosResponse with collection of users
 */
export const getUser  = async (id="me") => {
  return axios.get(`${USERS_URI}/${id}`,{
  })
  .then(responseHandler)
  .catch(errorHandler);
}

/**
 * Get users for specified community
 * @param  {number}  community_id - Specified community to retrieve users for
 * @param  {Object}  options - Additional filter options
 * @param  {boolean} options.internal - If enabled, only internal users will be returned
 * @return {Promise} AxiosResponse with collection of users
 */
export const getUsers = async (community_id, { internal=false }) => {
  return axios.post(`${USERS_URI}/invite`,{
  })
  .then(responseHandler)
  .catch(errorHandler);
}

/**
 * Update specified user 
 * @param {number|string} id - The desired user's id or 'me'
 * @param {object} user - Properties to update on specified user
 * @return {Promise} AxiosResponse with updated user details
 */
export const update = async (id, user) => {
  return axios.put(USERS_URI,{

  })
  .then(responseHandler)
  .catch(errorHandler);
}

/**
 * Invite user to community via email
 * @param  {number}  community_id - Specified community to retrieve users for
 * @param  {Object}  user - Data needed to create initialize new User
 * @param  {string}  user.first_name - Users first name
 * @param  {string}  user.last_name - Users last name
 * @param  {string}  user.email - Data needed to create initialize new User
 * @param  {array}   user.permissions - Array of permissions to be granted
 * @return {Promise} AxiosResponse with invited user details
 */

export const inviteByCommunity = async (community_id, { first_name, last_name, email, permissions }) => {
  return axios.post(`${USERS_URI}/invite`,{
  })
  .then(responseHandler)
  .catch(errorHandler);
}
